import React from "react";
import { X } from "lucide-react";

/**
 * Tiny absolute-positioned close button for any modal body.
 * Drop as the first child inside a modal body div with `relative` positioning.
 *
 *   <ModalCloseBtn onClose={() => setOpen(false)} />
 */
export default function ModalCloseBtn({ onClose, className = "", testId }) {
  return (
    <button
      type="button"
      onClick={onClose}
      aria-label="Close"
      data-testid={testId || "modal-close-btn"}
      className={`absolute top-3 right-3 p-1.5 rounded-lg bg-white/90 hover:bg-slate-100 text-slate-500 hover:text-slate-900 shadow-sm transition z-[1] ${className}`}
    >
      <X className="w-5 h-5" />
    </button>
  );
}
